import PriceFloorCalculator from "./PriceFloorCalculator";
import { PublicFooter, PublicHeader } from "../components/PublicPageChrome";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-cream text-ink font-body" data-testid="landing-page">
      <PublicHeader />
      <section className="max-w-5xl mx-auto px-5 pb-4 animate-rise">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-tea-text">
          For caterers, bakers, and private chefs
        </p>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight mt-2 max-w-3xl [text-wrap:balance]">
          Know exactly what to charge before you hit send.
        </h1>
        <p className="mt-4 text-ink/60 text-base sm:text-lg max-w-2xl [text-wrap:pretty]">
          Snap a receipt, build a recipe, and get a price floor for a quote. Or check one dish below, with no account.
        </p>
        <p className="mt-3 text-sm text-ink/50">
          Cost up to 2 real recipes free for 14 days. No card required.
        </p>
      </section>
      <PriceFloorCalculator embedded />
      <PublicFooter />
    </div>
  );
}
